import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop",
  "use": "icon-stop-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stop\">\r\n<g clip-path=\"url(#icon-stop_clip0_1759_16270)\">\r\n<rect x=\"5\" y=\"5\" width=\"6\" height=\"6\" rx=\"1\" fill=\"white\" />\r\n<circle cx=\"8\" cy=\"8\" r=\"7\" stroke=\"white\" stroke-width=\"1.1\" stroke-linecap=\"round\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"icon-stop_clip0_1759_16270\">\r\n<rect width=\"16\" height=\"16\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol